const filterStepDiffs = (diffs) => {
  return diffs.filter((n) => {
    const blacklistKeys = [
      'meta.attributes', //
      'meta.changes',
      'meta.errors',
      'meta.output',
      'meta.lastOpenedOn',
      'meta.lastRunArgsHash',
      'meta.lastRunOn',
      'meta.runCount',
      'meta.lastError',
      'meta.lastSuccess',
      'message',
      'updatedOn',
      'stepNumber',
      'isValid',
      'createdOn',
      'createdBy',
      'updatedBy',
      'arguments.isValidCode',
      'isValidCode',
      'arguments.activeIndex'
    ];

    if (typeof n?.key === 'string' && blacklistKeys.some((key) => n.key.startsWith(key))) {
      return false;
    }

    // Filter out empty notes
    return !(n?.key === 'options.notes' && (!n?.value || n?.value === '' || n?.value === '<p></p>'));
  });
};

export default filterStepDiffs;
